
import {calculator} from "@/front/js/components/calculator";
import {order} from "@/front/js/components/order";
import collapse from "@/front/js/components/collapse";
import leadForm from "@/front/js/components/leadForm";
import slider from "@/front/js/components/slider";
import {hashSlide} from "@/front/js/components/hashSlide";
import {scrollAfterRotation} from "@/front/js/components/scrollAfterRotation";
import {BP_DESKTOP, VIEWPORT_WIDTH} from "@/front/js/constants";
import {responsiveTable} from "@/front/js/components/responsive";
import {stickyHeader} from "@/front/js/components/stickyHeader";

if (document.querySelector(".page-pricelist")) {
	calculator();
}

if (document.querySelector(".order-content")) {
	order();
}

collapse.init();
leadForm.init();
slider.init();

hashSlide();
scrollAfterRotation();
stickyHeader(100);


if (VIEWPORT_WIDTH < BP_DESKTOP) {
	responsiveTable();
}

//
// $.nette.ext('jsplugins', {
// 	success: function (payload) {
// 		if (payload.snippets !== undefined) {
// 			let snippets = payload.snippets;
//
// 			for (let key in snippets) {
// 				// skip loop if the property is from prototype
// 				if (!snippets.hasOwnProperty(key))
// 					continue;
//
// 				initPlugins($("#" + key));
// 			}
// 		}
// 	}
// });
//
// $.nette.ext('javascript', {
// 	success: function (payload) {
// 		if (payload.javascript) {
// 			eval(payload.javascript);
// 		}
// 	}
// });
//
// $.nette.ext('history', {
// 	success: function (payload) {
// 		if (payload.url !== undefined) {
// 			history.replaceState({}, document.title, payload.url);
// 		}
// 	}
// });
//
// $.nette.init();

// initPlugins($(document));

$(window).on("load", function(){
	// $('.grid').isotope({
	// 	itemSelector: '.grid-item',
	// 	percentPosition: true,
	// 	masonry: {
	// 		columnWidth: '.grid-sizer',
	// 		gutter: '.gutter-sizer'
	// 	}
	// });
});


function initPlugins(scope){

	//Slider
	// $('.carousel', scope).carousel();

	//Fancybox for images inserted by tinyMCE
	$(".tinyMceText img", scope).wrap(function (foo) {
		if(!$(this).parent().is("a")) {
			return "<a href='" + $(this).attr("src") + "' data-fancybox/>";
		}
	}).addClass("img-fluid");

	//Justified gallery
	$(".justified-gallery", scope).justifiedGallery({
		rowHeight : 120,
		lastRow : 'nojustify',
		margins : 10
	});

	//complex vertical menu
	$(".complex-vertical-menu", scope).each(function(){
		let submenu = $(this);
		$(".toggleSubmenu", submenu).on("click", function(){
			let toggler = $(this);
			let id = toggler.data("id");

			$("#" + id).toggleClass("opened");
			$("#submenu-" + id).collapse("toggle");

			return false;
		})
	});

	//Submit on change
	$(".submitOnChange", scope).change(function(){
		$(this).closest("form").submit();
	});

	// let $flashMessage = $(".flash-message");
	// $flashMessage.modal("show");
}
